import { jsx as _jsx } from "react/jsx-runtime";
import { Component } from "react";
export class ErrorBoundary extends Component {
    constructor(props) {
        super(props);
        this.state = {
            videoUrl: props.videoUrl,
            helpdeskUrl: props.helpdeskUrl,
        };
    }
    componentDidCatch(error, info) {
        this.setState({ error, info });
    }
    render() {
        const { fallback, children, videoUrl, helpdeskUrl } = this.props;
        if (this.state.error !== undefined && this.state.info !== undefined) {
            const Fallback = fallback;
            return (_jsx(Fallback, { error: this.state.error, info: this.state.info, videoUrl: videoUrl, helpdeskUrl: helpdeskUrl }));
        }
        return children;
    }
}
//# sourceMappingURL=ErrorBoundary.js.map